import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators } from '@angular/forms';
//import { GeneralService } from '../../pages/Services/general.service';
import { GeneralService } from '../../Services/general.service'
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { FilterMatchMode } from 'primeng/api';
import Swal from 'sweetalert2';
import { MenuService } from '../../../theme/components/menu/menu.service';

import { Menu } from '../../../theme/components/menu/menu.model';
//import { MenuService } from '../../../theme/components/menu/menu.service';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { ToastrService, GlobalConfig } from 'ngx-toastr';
declare var $;
@Component({
  selector: 'app-category-management',
  templateUrl: './category-management.component.html',
  styleUrls: ['./category-management.component.scss'],
  providers: [DatePipe, MenuService]
})
export class CategoryManagementComponent implements OnInit {

  Category: string;
  CategoryData: any;
  filteredValuesLength: any;
  Status: any;
  LoginDetails: any;
  ModelTitle: string;
  templateoriginal: any;
  template: any;
  flag: any;
  ProjectStatus: any;
  cols: any;
  addNew: boolean;
  editForm: boolean;
  activitytype: any;
  Id: any;
  public form: FormGroup;
  Grid: boolean = true;
  myDate = new Date();
  todaydate: any;
  Pinned: boolean;
  PinId: any;
  MenuId: any;
  public settings: Settings;
  currentPageRoute: any;
  constructor(public config: PrimeNGConfig,
    public appSettings: AppSettings, public menuService: MenuService,
    //public menuService: MenuService,
    public router: Router, public toaster: ToastrService, public fb: FormBuilder, public generalService: GeneralService, private datePipe: DatePipe) {
    //this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.config.filterMatchModeOptions = {
      text: [
        FilterMatchMode.STARTS_WITH,
        FilterMatchMode.CONTAINS,
        FilterMatchMode.NOT_CONTAINS,
        FilterMatchMode.ENDS_WITH,
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
      ],
      numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
      ],
      date: [
        FilterMatchMode.BEFORE,
        FilterMatchMode.AFTER,
      ]
    }
    this.todaydate = formatDate(this.myDate, 'yyyy-MM-dd hh:mm:ss a', 'en-US', '+0530');
    this.LoginDetails = JSON.parse(localStorage.getItem('LoginDetails'))
    this.form = this.fb.group({
      activitytype: ['', Validators.required]
    });
    this.settings = this.appSettings.settings;
    this.MenuId = 0;
    this.router.events.subscribe((val) => {

      this.currentPageRoute = this.router.url; // Current page route

    });
  }

  ngOnInit(): void {
    this.getCategory();
    this.GetPinned();
  }
  //=======print====//
  onPrint() {
    window.print();
  }
  Pined() {
    debugger
    this.Pinned = true;

    let Array = [];
    Array.push({
      MenuId: this.MenuId, RouterLink: this.currentPageRoute, UserId: this.LoginDetails.logindetails.Id
    })
    var UploadFile = new FormData();
    UploadFile.append("Pinned", JSON.stringify(Array));
    var url = 'api/Values/AddPinned';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data == "SUCCESS") {
        debugger
        this.GetPinned();
        var UploadFile = new FormData();
        UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
        //UploadFile.append("flag", '1');
        var url = 'api/Values/GetSideMenusWithRecentPinned';
        this.generalService.PostData(url, UploadFile).then((data1: any) => {
          debugger
          var Details = this.generalService.SIdeMenus(data1);
          this.menuService.RefreshMenu(Details, this.settings.theme.menu);
          debugger
        });

      }

    });
  }


  UnPin() {
    debugger

    var UploadFile = new FormData();
    UploadFile.append("PinId", this.PinId);
    UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
    var url = 'api/Values/DeletePinned';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data == "SUCCESS") {
        debugger
        this.Pinned = false;
        var UploadFile = new FormData();
        UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
        //UploadFile.append("flag", '1');
        var url = 'api/Values/GetSideMenusWithRecentPinned';
        this.generalService.PostData(url, UploadFile).then((data1: any) => {
          debugger
          var Details = this.generalService.SIdeMenus(data1);
          this.menuService.RefreshMenu(Details, this.settings.theme.menu);
          debugger
        });
      }
    });
  }

  GetPinned() {
    debugger
    var UploadFile = new FormData();
    UploadFile.append("MenuId", this.MenuId);
    UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
    UploadFile.append("RouterLink", this.currentPageRoute);

    var url = 'api/Values/GetPinned';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data.MSG == "EXISTS") {
        debugger
        this.PinId = data.PinId;
        this.Pinned = true;
      }
      else if (data.MSG == "NOT EXISTS") {
        this.Pinned = false;
      }
    });
  }

  getCategory() {
    debugger
    var url = "api/Values/Getcategories";
    this.generalService.GetData(url).then((data: any) => {
      debugger
      if (data != null) {
        var obj = Object.keys(data[0])
        this.cols = [
          { field: 'Id', header: 'Id', width: '150px' },
          { field: 'Category', header: 'ProjectStatus', width: '150px' },
          { field: 'Status', header: 'Status', width: '150px' },
          { field: 'CreatedDate', header: 'CreatedDate', width: '150px' },
          { field: 'CreatedUser', header: 'CreatedBy', width: '150px' },
          { field: 'ModifiedDate', header: 'ModifiedDate', width: '150px' },
          { field: 'ModifiBy', header: 'ModifiedBy', width: '150px' },
        ]
        data.forEach(
          companyType => (companyType.CreatedDate = new Date(companyType.CreatedDate))
        );
        //data.forEach(
        //  companyType => (companyType.ModifiedDate = new Date(companyType.ModifiedDate))
        //);
        this.CategoryData = data;

        debugger
        for (var i = 0; i < data.length; i++) {
          if (data[i].ModifiedDate != null && data[i].ModifiedDate != undefined && data[i].ModifiedDate != '') {
            this.CategoryData[i].ModifiedDate = new Date(this.CategoryData[i].ModifiedDate)
          }
        }
        this.templateoriginal = data;
      }
    }, err => {
      // this.spinner.hide();
      this.generalService.ShowAlert('ERROR', 'Something Went wrong', 'error');
    });
  }

  OpenAddForm() {
    debugger
    this.ModelTitle = "Add Category";
    $('#myModal').modal('show');
    this.Grid = false;
    this.Category = "";
    this.flag = "1";
  }
  AddCategory() {
    debugger
    if (this.Category != "" && this.Category != undefined && this.Category != null) {
      let arr = [];
      arr = [{ 'Category': this.Category }]
      // this.onRowUpadte();
      this.flag = "2"//for Update        
      var UploadFile = new FormData();
      UploadFile.append("Categories", JSON.stringify(arr));
      UploadFile.append("flag", this.flag);
      var url = 'api/Values/AddCategory';
      this.generalService.PostData(url, UploadFile).then((data: any) => {
        if (data != null) {
          debugger
          $('#myModal').modal('hide');
          this.getCategory();
          this.toaster.success('ProjectStatus has been added successfully', 'Success', {
            timeOut: 2000,
          });
        }
      });
    }
    else {
      this.toaster.info('Please enter Project Status', 'Info', {
        timeOut: 2000,
      });
    }
  }
  TextBoxChange(item, key) {
    debugger
    let arr = [];
    arr = [{ 'Category': item.Category, Id: item.Id }]
    // this.onRowUpadte();
    this.flag = "2"//for Update        
    var UploadFile = new FormData();
    UploadFile.append("Categories", JSON.stringify(arr));
    var url = 'api/Values/UpdateCategory';
    this.generalService.PostData(url, UploadFile).then((data: any) => {

      if (data != null) {
        this.toaster.success('Category has been added successfully', 'Success', {
          timeOut: 2000,
        });
        this.getCategory();
        this.backform();
      }
    });
  }
  

  onDelete(rowData) {
    // this.onRowUpadte();
    Swal.fire({
      title: 'Are you sure to Delete  ?',
      //text: "",
      //type: 'warning',
      html: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      debugger
      if (result.value) {
        this.flag = "2"//for Update        
        var UploadFile = new FormData();
        UploadFile.append("CatId", rowData.Id);
        var url = 'api/Values/DeleteCategory';
        this.generalService.PostData(url, UploadFile).then((data: any) => {
          debugger
          if (data == "success") {
            this.getCategory();
            this.generalService.ShowAlert('SUCCESS', 'Category has been Deleted successfully', 'success');
            this.backform();
          }
          else {
            this.generalService.ShowAlert('WARNING', 'You can not delete this record because of it is having relation with another table', 'warning');
            this.backform();
          }
        });
      }
    })
  }
  changeStatus(rowData, status) {
    let arr = [];
    arr = [{ 'Status': status, Id: rowData.Id }]
    // this.onRowUpadte();
    this.flag = "2"//for Update        
    var UploadFile = new FormData();
    UploadFile.append("CatId", rowData.Id);
    UploadFile.append("Status", status);
    var url = 'api/Values/ActiveandDeactiveonCategory';
    this.generalService.PostData(url, UploadFile).then((data: any) => {

      if (data != null) {
        if (status != false) {
          this.toaster.success('Status Activated Successfully', 'Success', {
            timeOut: 2000,
          });
        }
        else {
          this.toaster.warning('Status Dectivated Successfully', 'Success', {
            timeOut: 2000,
          });
        }

        this.getCategory();
        this.backform();
      }
    });
     }

  backform() {
    ;
    this.Grid = true;
  }
  refresh() {
    location.reload();
  }

}
